import type { SessionStatusResponse } from '@/lib/api/auth';

const REFRESH_SESSION_MARKER_NAME = 'csrf_token';
const CSRF_COOKIE_PATTERN = new RegExp(`(?:^|; )${REFRESH_SESSION_MARKER_NAME}=([^;]+)`);

export function hasRefreshSessionMarker(cookieHeader: string): boolean {
  return CSRF_COOKIE_PATTERN.test(cookieHeader);
}

/**
 * Expires the readable refresh-session marker. Called once a bootstrap refresh
 * has proven the marker stale (its bound session no longer exists, so the
 * refresh returned 401/403). Without this the dead marker survives every reload
 * and keeps firing a doomed refresh on each page load.
 */
export function clearRefreshSessionMarker(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${REFRESH_SESSION_MARKER_NAME}=; path=/; max-age=0`;
}

export function shouldRefreshSessionBootstrap(
  session: SessionStatusResponse,
  cookieHeader: string,
  refreshAttempted: boolean
): boolean {
  return !session.authenticated && !refreshAttempted && hasRefreshSessionMarker(cookieHeader);
}

export type WebSocketAuthCloseAction = 'refresh' | 'logout' | 'reconnect';

export function getWebSocketCloseAction(code: number, authRecoveryAttempted: boolean): WebSocketAuthCloseAction {
  if (code !== 4001 && code !== 1008) return 'reconnect';
  return authRecoveryAttempted ? 'logout' : 'refresh';
}
